module.exports = __webpack_public_path__ + "static/media/cases_3d_07c.0afc925a.jpg";